import {
  ChannelsGroups,
  ChannelId,
} from '@make-transfer/types/common';

export const channelsGroupsMapper = {
  [ChannelsGroups.MyAccounts]: [
    ChannelId.Internal,
    ChannelId.External,
    ChannelId.Investment,
  ],
  [ChannelsGroups.Others]: [
    ChannelId.Wire,
    ChannelId.M2M,
    ChannelId.P2P,
    ChannelId.ACH,
    ChannelId.Invoices,
    ChannelId.BillPay,
    ChannelId.CheckWithdrawal,
    ChannelId.StopCheck,
    ChannelId.Skip,
    ChannelId.PayByCard,
  ],
} as {[key: string]: string[]};
